<div class="d-flex flex-column h-100">
    <header class="shadow w-100 pb-2">
        <div class="container">
            <shared-default-navigation></shared-default-navigation>
        </div>
    </header>
    <div class="container mta-content h-auto-calc align-items-stretch pt-5 pb-4 overflow-auto">
        <router-outlet></router-outlet>
    </div>
    <footer class="position-relative fixed-bottom">
        <shared-default-menu></shared-default-menu>
    </footer>
</div>
